<template>
    <div class="row">
        <div class="col-12">
            <wistia-video :video-id="videoId"/>
        </div>
        <div class="col-12">
            <accordion-group :accordions="accordions" :id="id"/>
        </div>
    </div>
</template>

<script>
    import BlockHeader from "../../../molecules/BlockHeader";
    import WistiaVideo from "./WistiaVideo";
    import AccordionGroup from "./AccordionGroup";

    export default {
        name: "VideoWithAccordion",
        components: { WistiaVideo, AccordionGroup},
        props:{
            header: Object,
            accordions: Array,
            videoId: String,
            id: Number
        }
    }
</script>

<style scoped>

</style>